import { Auth } from 'school-space-client/components';
import { getCustomer } from 'school-space-client/api';

import { analytics, api, errorHandler } from '../services';

class AuthHandler extends Auth {
    constructor() {
        const {
            REACT_APP_AUTH0_DOMAIN: domain,
            REACT_APP_AUTH0_CLIENT_ID: clientID,
            REACT_APP_AUTH0_TENANCY: tenancy,
            REACT_APP_BASE_URL: baseUrl
        } = process.env;
        const auth0Config = {
            domain,
            clientID,
            tenancy,
            realm: 'Username-Password-Authentication'
        };

        super(auth0Config, baseUrl);
    }

    setApiToken(idToken) {
        api.setToken(idToken);
    }

    async fetchUser(idTokenPayload) {
        const customerId = idTokenPayload['https://school-space.org/entity_id'];
        const {
            id,
            email,
            firstName,
            lastName,
            name,
            phone,
            organisation,
            address,
            termsAgreed,
            supportingDocuments,
            customerDeposits,
            joined,
            customerType,
            stripeCustomerId
        } = await getCustomer(customerId);

        this.setUser({
            id,
            email,
            firstName,
            lastName,
            name,
            phone,
            organisation,
            address,
            termsAgreed,
            customerDeposits,
            supportingDocuments,
            showRebooking: true,
            joined,
            customerType,
            stripeCustomerId,
            setTermsAgreed: value => this.setUser({ termsAgreed: value }),
            setCustomerDeposits: deposit => this.setUser({ customerDeposits: deposit }),
            setSupportingDocuments: document => this.setUser({ supportingDocuments: document })
        });

        analytics.set({ userId: id });
        errorHandler.setUser(id);
    }
}

export default new AuthHandler();
